import {Link, styled, Typography} from '@mui/material';

const StyledDescription = styled(Typography)`
	text-align: center;
	color: ${({theme}) => theme.colors.light.text.primary};
`;

const StyledLink = styled(Link)`
	padding: 0;
	min-width: auto;
	vertical-align: baseline;
	cursor: pointer;
	font-size: 16px;
`;

export {StyledDescription, StyledLink};
